import { render } from "./OfficesCard.vue?vue&type=template&id=0ffa7ee2&scoped=true"
import script from "./OfficesCard.vue?vue&type=script&lang=js"
export * from "./OfficesCard.vue?vue&type=script&lang=js"

import "./OfficesCard.vue?vue&type=style&index=0&id=0ffa7ee2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ffa7ee2"]])

export default __exports__